/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum ColorType {
	Roles = 'roles',
	Locations = 'locations',
}
